import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Modal as ModalComponent } from 'reactstrap';

import { buttonsV2 as Buttons, formsV2 as Forms } from '@breezeway/brzw-components';
import { account } from '@breezeway/brzw-react-core';
import datastore from '@datastore';

import './saved_view_dialog.scss';

const { BUTTON_SIZES, BUTTON_THEMES } = Buttons.constants;
const CLASS_NAME = 'saved-view-dialog';
const SELECTION = {
  COMPANY: 'company',
  PRIVATE: 'private',
};

export class SavedViewDialog extends Component {
  constructor(props) {
    super(props);
    const { isServicePartner } = this.props;

    this.state = {
      isError: false,
      isLoading: false,
      selection: isServicePartner ? SELECTION.PRIVATE : SELECTION.COMPANY,
      viewName: props.viewName,
    };

    this.inputRef = React.createRef();

    this.onBlurInputFiled = this.onBlurInputFiled.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
    this.onFocusInputField = this.onFocusInputField.bind(this);
    this.onNameChange = this.onNameChange.bind(this);
    this.onRadioChange = this.onRadioChange.bind(this);
    this.onSaveClick = this.onSaveClick.bind(this);
  }

  componentDidMount() {
    _.invoke(this.inputRef, 'current.focus');
  }

  onBlurInputFiled() {
    const { viewName } = this.state;

    if (_.isEmpty(viewName)) {
      this.setState({
        isError: true,
      });
    }
  }

  onFocusInputField() {
    this.setState({
      isError: false,
    });
  }

  onCloseClick() {
    _.invoke(this.props, 'onCloseClick');
  }

  onRadioChange(selection) {
    return () => {
      this.setState({
        selection,
      });
    };
  }

  onNameChange(value) {
    this.setState({
      viewName: value,
    });
  }

  onSaveClick() {
    const { category, data, loadSavedViews, saveView, viewType } = this.props;
    const { selection, viewName } = this.state;

    const requestData = {
      category,
      data,
      module: viewType,
      name: viewName,
      private: selection === SELECTION.PRIVATE,
    };

    this.setState({
      isLoading: true,
    });

    saveView(requestData, result => {
      loadSavedViews();
      _.invoke(this.props, 'onSaveSuccess', result);
      this.onCloseClick();
    });
  }

  renderRadioElement({ description, image, isChecked, selection, title }) {
    const inputId = `input-${image}`;
    return (
      <div className={`${CLASS_NAME}__radio`}>
        <input
          checked={isChecked}
          className={`${CLASS_NAME}__radio-button`}
          id={inputId}
          onChange={this.onRadioChange(selection)}
          type="radio"
        />
        <label className={`${CLASS_NAME}__radio-button-label`} htmlFor={inputId} />
        <div
          className={classnames(`${CLASS_NAME}__radio-icon`, `icon-${image}`, {
            [`${CLASS_NAME}__radio-icon--selected`]: isChecked,
          })}
        />
        <div className={`${CLASS_NAME}__radio-content`}>
          <p className={`${CLASS_NAME}__radio-title`}>{title}</p>
          <p className={`${CLASS_NAME}__radio-description`}>{description}</p>
        </div>
      </div>
    );
  }

  render() {
    const { companyName, isServicePartner } = this.props;
    const { isError, isLoading, selection, viewName } = this.state;
    const isViewNameEmpty = _.isEmpty(_.trim(viewName));
    return (
      <ModalComponent
        backdropClassName={`${CLASS_NAME}__backdrop`}
        className={CLASS_NAME}
        contentClassName={`${CLASS_NAME}__modal-content`}
        isOpen
        toggle={this.onCloseClick}
        zIndex={3000}
      >
        <div className={`${CLASS_NAME}__title-wrapper`}>
          <div />
          <p className={`${CLASS_NAME}__title`}>Save this view</p>
          <div
            className={classnames(`${CLASS_NAME}__close-button`, 'icon-close')}
            onClick={this.onCloseClick}
            role="presentation"
          />
        </div>
        <Forms.Input
          additionalSubText={isViewNameEmpty ? 'Name your view to save' : ''}
          inputRef={this.inputRef}
          labelText="View name"
          onBlurInput={this.onBlurInputFiled}
          onChange={this.onNameChange}
          onFocusInput={this.onFocusInputField}
          value={viewName}
          withError={isError}
        />
        <div className={`${CLASS_NAME}__separator`} />
        <p className={`${CLASS_NAME}__setting-title`}>SHARE SETTING</p>
        <div className={`${CLASS_NAME}__radio-group`}>
          {!isServicePartner &&
            this.renderRadioElement({
              isChecked: selection === SELECTION.COMPANY,
              description: `Anyone at ${companyName} with access to this page can use this view`,
              image: 'users',
              selection: SELECTION.COMPANY,
              title: companyName,
            })}
          {this.renderRadioElement({
            isChecked: selection === SELECTION.PRIVATE,
            description: 'Only visible to you',
            image: 'lock',
            selection: SELECTION.PRIVATE,
            title: 'Private',
          })}
        </div>
        <div className={`${CLASS_NAME}__buttons-wrapper`}>
          <Buttons.TextButton
            onClick={this.onCloseClick}
            theme={BUTTON_THEMES.DEFAULT}
            size={BUTTON_SIZES.LARGE}
          >
            Cancel
          </Buttons.TextButton>
          <Buttons.TextButton
            className={`${CLASS_NAME}__button`}
            disabled={isViewNameEmpty}
            isLoading={isLoading}
            onClick={this.onSaveClick}
            theme={BUTTON_THEMES.PRIMARY}
            size={BUTTON_SIZES.LARGE}
          >
            Save view
          </Buttons.TextButton>
        </div>
      </ModalComponent>
    );
  }
}

SavedViewDialog.propTypes = {
  category: PropTypes.string,
  data: PropTypes.shape({}),
  companyName: PropTypes.string,
  isServicePartner: PropTypes.bool,
  loadSavedViews: PropTypes.func,
  onCloseClick: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
  onSaveSuccess: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
  saveView: PropTypes.func,
  viewName: PropTypes.string,
  viewType: PropTypes.string,
};

const mapStateToProps = state => ({
  isServicePartner: datastore.selectors.company.isServicePartner(state),
});

export default connect(
  mapStateToProps,
  {
    loadSavedViews: account.actionsV3.getSavedViews,
    saveView: account.actionsV3.createSavedView,
  },
)(SavedViewDialog);
